import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const defaultStyles = css`
  display: inline-flex;
  justify-content: center;
  align-items: center;

  font-family: ${themeGet('fonts.primary')};
  font-weight: ${themeGet('font-weights.semi-bold')};
  text-align: center;
  border-radius: 4px;
  border: none;

  /* font-size: 15px;
  letter-spacing: -0.2px;
  line-height: 18px; */

  font-size: 1rem;
  letter-spacing: -0.5px;
  line-height: 1.9375rem;

  height: 45px;
  min-height: 45px;
  min-width: 120px;

  padding: 0 3rem;

  transition: all 500ms ease;

  &:disabled {
    cursor: not-allowed;
    border: 1px solid ${themeGet('colors.spinDark')};
    background-color: white;
    color: ${themeGet('colors.spinDark')};
    opacity: 0.75;

    &:hover,
    &:focus {
      cursor: not-allowed;
      border: 1px solid ${themeGet('colors.spinDark')};
      background-color: white;
      color: ${themeGet('colors.spinDark')};
      opacity: 1;
    }
  }

  /* Make all buttons 100% width on mobile unless auto-size is set as a className */
  @media only screen and (max-width: calc(${themeGet(
      'breakpoints.md'
    )} - 1px)) {
    min-width: 135px;
    font-size: 0.875rem;
    line-height: 1.0625rem;
    padding: 0 1.625rem;

    &.auto-size {
      width: auto;
    }
  }
`;

export const ButtonStyles = css`
  &.defaultButton {
    font-size: 1em;
    font-weight: 600;
    line-height: inherit;
    letter-spacing: inherit;
    color: ${themeGet('spinTextDark')};
    text-decoration: none;
    background-color: white;
    border-radius: 36.5px;
    padding: 0px 40px;
    min-height: 45px;
    height: 45px;
    margin-bottom: 1rem;
    display: inline-flex;
    align-items: center;
    /* width: 200px; */
    text-align: center;
    @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
      font-size: 0.875rem;
    }
  }
  /* Date Filter */
  &.date-filter {
    ${defaultStyles}
    color: ${themeGet('spinTextDark')};
    font-weight: 900;
  }
  /* Solid Orange -> Solid Darker Orange -> Darkest Orange*/
  &.solid-on-light-bg {
    ${defaultStyles}
    border: 3px solid ${themeGet('colors.spinSecondaryOne')};
    border-radius: 36.5px;
    background-color: ${themeGet('colors.spinSecondaryOne')};
    color: ${themeGet('colors.primary')};

    &:hover,
    &:focus {
      border: 3px solid ${themeGet('colors.spinSecondaryOne')};
      background-color: ${themeGet('colors.spinSecondaryOne')};
    }

    &:focus,
    &:active {
      border: 3px solid ${themeGet('colors.spinSecondaryOne')};
      background-color: ${themeGet('colors.spinSecondaryOne')};
    }
  }

  /* Solid Orange -> Solid Darker Orange -> Darkest Orange*/
  &.solid-on-dark-bg {
    ${defaultStyles}
    border: 1px solid ${themeGet('colors.spinSecondaryOne')};
    border-radius: 36.5px;
    background-color: ${themeGet('colors.spinSecondaryOne')};
    color: ${themeGet('spinTextDark')};

    &:hover,
    &:focus {
      border: 1px solid ${themeGet('spinTextDark')};
      border-radius: 36.5px;
      background-color: ${themeGet('colors.white')};
    }

    &:focus,
    &:active {
      border: 1px solid ${themeGet('spinTextDark')};
      border-radius: 36.5px;
      background-color: ${themeGet('colors.white')};
    }

    &.hvr-bounce-to-right {
      &:hover {
        /* border: none !important; */
      }
      &:before {
        background-color: ${themeGet('colors.white')};
      }
    }
  }

  /* Ghost Orange -> Solid Darker Orange -> Darkest Orange*/
  &.ghost-on-light-bg {
    ${defaultStyles}
    border: 3px solid ${themeGet('colors.spinSecondaryOne')};
    background-color: transparent;
    color: ${themeGet('colors.black')};

    &:hover,
    &:focus {
      color: ${themeGet('colors.white')};
      background-color: ${themeGet('colors.spinSecondaryOne')};
    }

    &:focus,
    &:active {
      color: ${themeGet('colors.white')};
      border: 3px solid ${themeGet('colors.spinSecondaryOne')};
      background-color: ${themeGet('colors.spinSecondaryOne')};
    }
  }

  /* Ghost White -> Solid Orange*/
  &.ghost-on-dark-bg {
    ${defaultStyles}
    border: 3px solid ${themeGet('colors.spinSecondaryOne')};
    background-color: transparent;
    color: ${themeGet('colors.white')};

    &:hover,
    &:focus {
      border: 3px solid ${themeGet('colors.spinSecondaryOne')};
      background-color: ${themeGet('colors.spinSecondaryOne')};
    }

    &:focus,
    &:active {
      border: 3px solid ${themeGet('colors.spinSecondaryOne')};
      background-color: ${themeGet('colors.spinSecondaryOne')};
    }
  }

  /* Brand Neutral*/
  &.brand-neutral {
    ${defaultStyles}
    outline: none;
    &:hover,
    &:focus {
      border-radius: 36.5px;
      background-color: ${themeGet('colors.spinSecondaryFour')};
    }

    &:focus,
    &:active {
      border-radius: 36.5px;
      background-color: ${themeGet('colors.spinSecondaryFour')};
    }
  }
  /* Solid White -> Solid spinSecondaryFour*/
  &.brand-solid {
    ${defaultStyles}
    border-radius: 36.5px;
    background-color: ${themeGet('colors.white')};
    color: ${themeGet('colors.black')};

    &:hover,
    &:focus {
      border: 3px solid ${themeGet('colors.spinSecondaryFour')};
      border-radius: 36.5px;
      background-color: #${themeGet('colors.spinSecondaryFour')};
    }

    &:focus,
    &:active {
      border: 3px solid #ebeae8;
      background-color: #ebeae8;
    }
  }

  /* Ghost White -> Solid Black */
  &.brand-ghost {
    ${defaultStyles}
    border: 3px solid ${themeGet('colors.white')};
    background-color: transparent;
    color: ${themeGet('colors.white')};

    &:hover,
    &:focus {
      color: ${themeGet('colors.black')};
      border: 3px solid ${themeGet('colors.spinSecondaryFour')};
      background-color: ${themeGet('colors.spinSecondaryFour')};
    }

    &:focus,
    &:active {
      color: ${themeGet('colors.black')};
      border: 3px solid #ebeae8;
      background-color: #ebeae8;
    }
  }

  &.brand-blue {
    height: 55px;
    width: auto;
    font-size: 1rem;
    color: ${themeGet('colors.spinDark')};
    text-decoration: none;
    background-color: white;
    padding: 17px 40px;
    text-align: center;
    box-sizing: border-box;
    border: 1px solid ${themeGet('colors.spinDark')};
    border-radius: 36.5px;
    transition: color 0.3s;
    font-weight: 600;

    &:hover {
      color: ${themeGet('colors.white')};
    }

    &.hvr-bounce-to-right:before {
      background-color: ${themeGet('colors.spinDark')};
    }
  }

  &.brand-ultraDark {
    height: 55px;
    width: auto;
    font-size: 1rem;
    font-weight: 600;
    color: ${themeGet('colors.spinTextDark')};
    text-decoration: none;
    background-color: white;
    padding: 17px 40px;
    text-align: center;
    box-sizing: border-box;
    border: 1px solid ${themeGet('colors.spinTextDark')};
    border-radius: 36.5px;
    transition: color 0.3s;

    &:hover {
      color: ${themeGet('colors.white')};
    }

    &.hvr-bounce-to-right:before {
      background-color: ${themeGet('colors.spinTextDark')};
    }
  }
  &.small {
    height: 45px;
    padding: 12px 40px;
  }

  &.spin-dark {
    ${defaultStyles}
    display: block;
    border-radius: 36.5px;
    border: 1px solid ${themeGet('colors.spinDark')};
    background-color: ${themeGet('colors.spinDark')};
    color: ${themeGet('colors.white')};
    &:hover{
      color: ${themeGet('colors.spinDark')};
      background-color: transparent;
    }
    
  }

`;

export const Btn = styled.button`
  ${ButtonStyles}
`;
